import React, { useState } from "react";
import {
	Chart as ChartJS,
	LinearScale,
	PointElement,
	LineElement,
	Tooltip,
	Legend,
} from "chart.js";
import { Bubble } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import { Button } from "rsuite";
import annotationPlugin from "chartjs-plugin-annotation";
import {
	numberFormatter,
	numberFormatterForCPGraph,
	setTicks,
} from "../../utils";
import { ReferenceArea } from "recharts";
ChartJS.register(
	LinearScale,
	PointElement,
	LineElement,
	Tooltip,
	Legend,
	zoomPlugin,
	annotationPlugin
);
let maxx = 20;
let minn = 20;
// const dragColor = Utils.randomColor(0.4);
const zoomOptions = {
	pan: {
		enabled: true,
		mode: "xy",
		modifierKey: "ctrl",
	},
	zoom: {
		mode: "xy",
		drag: {
			enabled: true,
			borderColor: "rgb(54, 162, 235)",
			borderWidth: 1,
			backgroundColor: "rgba(54, 162, 235, 0.3)",
		},
	},
};
export function BubbleScatterWithZoom(props: any) {
	const { selectedCustomerData, customerData } = props;
	let graphData: any = [];
	let labels: any = [];
	let backgroundColor: any = [];
	let borderColor: any = [];
	let priceList: any = [];
	let YscaleMax: any = 0;
	let YscaleMin: any = 0;
	let max = 0;
	let yTicks = setTicks(props.minYAxis, props.maxYAxis);
	// console.log(yTicks);
	// const domain= {([dataMin : any, dataMax : any]) => {
	//   const divFactor = dataMax > 100 ? 20 : 10;
	//   return [Math.floor(Math.min(dataMin) / divFactor) * divFactor, Math.ceil(dataMax / divFactor) * (divFactor)];
	//   }}
	const domain = (dataMin: any, dataMax: any) => {
		const divFactor = dataMax > 100 ? 20 : 10;
		return [
			Math.floor(Math.min(dataMin) / divFactor) * divFactor,
			Math.ceil(dataMax / divFactor) * divFactor,
		];
	};
	const generateRandomColour = () => {
		var x = Math.floor(Math.random() * 256);
		var y = Math.floor(Math.random() * 256);
		var z = Math.floor(Math.random() * 256);
		var bgColor = "rgb(" + x + "," + y + "," + z + ")";
		return bgColor;
	};
	const customTooltip = (context: any) => {
		const { chart, tooltip } = context;
		let tooltipEl = document.getElementById("bubble-custom-tooltip");

		if (!tooltipEl) {
			tooltipEl = document.createElement("div");
			tooltipEl.id = "bubble-custom-tooltip";
			tooltipEl.style.position = "absolute";
			tooltipEl.style.zIndex = "9999";
			document.body.appendChild(tooltipEl);
		}

		if (tooltip.opacity === 0) {
			tooltipEl.style.opacity = "0";
			return;
		}

		tooltipEl.style.background = "white";
		tooltipEl.style.color = "black";
		tooltipEl.style.border = "1px solid #ccc";
		tooltipEl.style.boxShadow = "0 2px 5px rgba(0,0,0,0.2)";
		tooltipEl.style.borderRadius = "1vh";
		tooltipEl.style.padding = "4px";
		tooltipEl.style.fontSize = "12px";
		tooltipEl.style.pointerEvents = "none";

		if (tooltip.body) {
			const dataIndex = tooltip.dataPoints[0].dataIndex;
			const element = customerData[dataIndex];

			tooltipEl.innerHTML = `
            <div style="font-weight:bold;background-color:#f0f4f8 ;margin-bottom:4px;">Customer: ${
				element.customerName
			}</div>
            <div>Project Flag: ${element.project_flag}</div>
            <div>Price: $${numberFormatter(element.price, 2)}</div>
            <div>Qty Purchased: ${numberFormatter(element.quantity)}</div>
            <div>Revenue: $${numberFormatter(element.revenue, 2)}</div>
        `;
		}

		const { offsetLeft: chartLeft, offsetTop: chartTop } = chart.canvas;
		tooltipEl.style.opacity = "1";
		tooltipEl.style.left = chartLeft + tooltip.caretX + "px";
		tooltipEl.style.top = chartTop + tooltip.caretY + "px";
	};
	let colour: any = {};
	let maxValue = customerData?.reduce(
		(acc: any, value: any) => (acc > value.revenue ? acc : value.revenue),
		0
	);
	customerData?.forEach((d: any) => {
		// Calculate radius based on revenue
		const minRadius = 5;
		const maxRadius = 15;
		const r = maxValue
			? (d.revenue / maxValue) * (maxRadius - minRadius) + minRadius
			: minRadius;

		graphData.push({ x: maxx, y: d.price, r });

		if (d?.Customer === selectedCustomerData?.Customer) {
			backgroundColor.push("#DA505582");
			borderColor.push("#fff");
		} else {
			backgroundColor.push("#62B5E582");
			borderColor.push("#62B5E582");
		}
	});
	const data: any = {
		labels: labels,
		datasets: [
			{
				data: graphData,
				backgroundColor: backgroundColor,
				borderColor: borderColor,
			},
		],
	};
	const findClosestIndex = (yAxisArr: any, ReferenceLine: any) => {
		let closestIndex = 0;
		let smallestDifference = Math.abs(yAxisArr[0] - ReferenceLine);
		for (let index = 0; index < yAxisArr.length; index++) {
			let currentDifference = Math.abs(yAxisArr[index] - ReferenceLine);
			if (currentDifference < smallestDifference) {
				smallestDifference = currentDifference;
				closestIndex = index;
			}
		}
		return closestIndex;
	};
	const options: any = {
		onClick: function (e: any) {
			props.handleClick(props.data[e.chart._active[0].index], true);
		},
		maintainAspectRatio: false,
		plugins: {
			annotation: {
				annotations: {
					line1: {
						display:
							selectedCustomerData?.peer_price !== null
								? true
								: false,
						type: "line",
						drawTime: "beforeDatasetsDraw",
						yMin: selectedCustomerData?.peer_price,
						yMax: selectedCustomerData?.peer_price,
						xMin: 4,
						xMax: props.openPopup ? 35 : props?.index ? 100 : 35,
						borderWidth: 3,
						borderColor: "#A0519580",
						borderDash: [8, 8],
						enter: function ({ element }: { element: any }) {
							element.label.options.display = true;
							return true;
						},
						leave: function ({ element }: { element: any }) {
							element.label.options.display = false;
							return true;
						},
						label: {
							display: false,
							xAdjust: 30,
							content:
								"Target Price: " +
								Number(
									selectedCustomerData?.peer_price
								).toFixed(5), // 5 decimal places
							position: "end",
							font: {
								size: 14,
								weight: "bold",
								family: "inherit",
							},
							color: "black", // Ensure label text is black
							backgroundColor: "white", // Ensure label background is white
							padding: 6, // Optional: add some padding for clarity
							borderRadius: 4, // Optional: rounded corners
							borderWidth: 1,
							borderColor: "#ccc",
						},
					},
					line5: {
						display:
							selectedCustomerData?.FloorPrice !== null
								? true
								: false,
						type: "line",
						drawTime: "beforeDatasetsDraw",
						yMin: selectedCustomerData?.FloorPrice,
						yMax: selectedCustomerData?.FloorPrice,
						xMin: 4,
						xMax: props.openPopup ? 35 : props?.index ? 100 : 35,
						borderWidth: 3,
						borderColor: "#86BC2582",
						borderDash: [8, 8],
						enter: function ({ element }: { element: any }) {
							element.label.options.display = true;
							return true;
						},
						leave: function ({ element }: { element: any }) {
							element.label.options.display = false;
							return true;
						},
						label: {
							display: false,
							xAdjust: 30,
							content:
								"Floor Price: " +
								Number(
									selectedCustomerData?.FloorPrice
								).toFixed(5), // 5 decimal places
							position: "end",
							font: {
								size: 14,
								weight: "bold",
								family: "inherit",
							},
							color: "black",
							backgroundColor: "white",
							padding: 6,
							borderRadius: 4,
							borderWidth: 1,
							borderColor: "#ccc",
						},
					},
					box1: {
						type: "box",
						drawTime: "beforeDatasetsDraw",
						// xmax : maxx,
						xMin: props?.index ? (props?.index == 0 ? 0 : 5) : 4,
						xMax: props?.index
							? props?.index == 0
								? 100
								: 100
							: 35,
						yMin: yTicks[0],
						yMax: yTicks[
							findClosestIndex(yTicks, props.referenceLine) + 5
						],
						// yMax: props.referenceLine +  props.referenceLine * 0.1 ,
						borderWidth: 0,
						borderColor: "black",
						backgroundColor: "#EAA61433",
					},
				},
			},
			zoom: zoomOptions,
			tooltip: {
				enabled: false, // Disable default tooltip
				external: customTooltip, // Use custom external tooltip
			},
			legend: {
				display: false,
				labels: {
					usePointStyle: true,
					boxWidth: 5,
					boxHeight: 5,
					color: "yellow",
				},
				position: "bottom",
				align: "end",
			},
		},
		scales: {
			x: {
				offset: true,
				display: false,
				// display: true,
				border: {
					color: "black",
				},
				// beginAtZero: true,
				//max: props.xAxisRange.maxRange+10,
				title: {
					display: true,
					text: "Vol/Drop",
					color: "black",
					font: {
						size: 12, // match Recharts axis label size
					},
				},
				grid: {
					display: false,
				},
				ticks: {
					display: false,
					min: minn,
					max: maxx,
					// max:xTicks[xTicks.length-1],
					maxTicksLimit: 4,
					callback: function (val: any) {
						return numberFormatterForCPGraph(Math.exp(val), 0);
					},
					color: "black",
				},
			},
			y: {
				suggestedMin: props.minYAxis,
				beginAtZero: false,
				//max: props.yAxisRange.maxRange+10,
				title: {
					display:
						props?.index === 0
							? true
							: !props?.index
							? true
							: false,
					text: "Price/Unit($)",
					color: "black",
					font: {
						size: 14, // match Recharts axis label size
					},
				},
				grid: {
					display: false,
				},
				ticks: {
					display:
						props?.index === 0
							? true
							: !props?.index
							? true
							: false,
					// maxTicksLimit: 4,
					color: "black",
					font: {
						size: 14,
					},
					autoSkip: true,
					maxTicksLimit: 5,
					// min: yTicks[0],
					// stepSize: 1,
					// max: yTicks[findClosestIndex(yTicks , props.referenceLine) * 1.2],
					// yMax: props.referenceLine + props.referenceLine * 0.1,
					callback: function (value: any) {
						return "$" + value.toFixed(2);
					},
				},
			},
		},
	};
	const chartRef: any = React.useRef(null);
	const handleResetZoom = () => {
		if (chartRef && chartRef.current) {
			chartRef.current.resetZoom();
		}
	};
	return (
		<div className="h-full  justify-center">
			<Bubble
				// height={500}
				ref={chartRef}
				options={options}
				data={data}
			/>
			<div className="flex items-center justify-between w-full mt-4">
				<Button
					onClick={handleResetZoom}
					style={{
						color: "white",
						background: "#86bc25",
						left: "0.5vh",
						width: "8vw",
						borderRadius: "5px",
						// marginLeft: "1vw",
					}}
					appearance="default"
					size="sm"
				>
					Reset Zoom
				</Button>
				<div className="flex justify-start">
					<span>
						<span
							style={{
								display: "inline-block",
								width: 10,
								height: 18,
								background: "rgba(255, 99, 132)",
								marginRight: 8,
								verticalAlign: "middle",
							}}
						/>
					</span>
					<span
						className="text-[1.4vh] mr-2"
						style={{ display: "flex", alignItems: "center" }}
					>
						Target Price
					</span>

					<span>
						<span
							style={{
								display: "inline-block",
								width: 10,
								height: 18,
								background: "rgba(228, 232, 99)",
								marginRight: 8,
								verticalAlign: "middle",
							}}
						/>
					</span>
					<span
						className="text-[1.4vh]"
						style={{ display: "flex", alignItems: "center" }}
					>
						Floor Price
					</span>
				</div>
			</div>
		</div>
	);
}
